import { Box } from '@mui/material';
import React from 'react';
import { AdminDataTable } from '../../components';
import { ADMIN_USERS_ROWS_PER_PAGE } from '../../constants';
import { getUserColumns } from '../../functions';
import { useUsersTab } from '../../hooks';
import type { IUserRow, IUsersTabProps } from '../../interfaces';

export const UsersTab = ({ searchTerm }: IUsersTabProps) => {
  const {
    usersData,
    onPageChange,
    pageNumber,
    totalPages,
    loading,
    totalRecords,
    handleRowClick,
  } = useUsersTab(searchTerm);

  const columns = getUserColumns(handleRowClick);

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <AdminDataTable<IUserRow>
        columns={columns}
        rows={usersData}
        isLoading={loading}
        currentPage={pageNumber}
        totalPages={totalPages}
        totalRecords={totalRecords}
        rowsPerPage={ADMIN_USERS_ROWS_PER_PAGE}
        onPageChange={onPageChange}
        onRowClick={handleRowClick}
        emptyTitle="No Users Found"
        emptySubtitle="There are currently no users matching your criteria."
      />
    </Box>
  );
};
